import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { Modal, Row, Col, Table, message } from 'antd';
import { useSelector } from 'react-redux';
import { AutoComplete } from '../../../components/autoComplete/autoComplete';
// import { getBaseURL } from '../../../Api/ApiConfig';
// import Heading from '../../../components/heading/heading';
import { CampaignUpdate } from '../../../Api/Services/CampaignApiServices';
import { Button } from '../../../components/buttons/buttons';


const Popup = ({ openUser, usersTableColumns, filterDatas, exportData, OpenUserTable,
    selectedRowKeys, setFilterDatas, displayData, getCampaignData, page, setExistLead }) => {
    const localData = useSelector((state) => state.localRedux);
    const companyProfile = localData.company
    const [searchText, setSearchText] = useState("");
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [display, setDisplay] = useState(false)
    const [selectedRowKeysPopup, setSelectedRowKeysPopup] = useState([]);
    const onSelectChangePopup = (newSelectedRowKeys) => {
        setSelectedRowKeysPopup(newSelectedRowKeys);
    };
    function getDateFromTimezoneString() {
        if (!companyProfile?.timeZone) return null;

        // Extract "Australia/Sydney" or any region part after ") "
        const match = companyProfile?.timeZone.match(/\)\s(.+?)(?:\s\d{2}:\d{2}:\d{2})?$/);

        if (!match) return null;

        const timeZone = match[1]; // Region only

        const date = new Date();
        return date.toLocaleDateString("en-CA", {
            timeZone
        });
    }
    const rowSelectionPopup = {
        selectedRowKeysPopup,
        onChange: onSelectChangePopup,
    };
    function updateCampaignIds(campaign, newIds, type) {
        const field = type === 'Lead' ? 'leads' : 'contacts';
        const existingIds = campaign[field]
            ? campaign[field].split(',').map(id => parseInt(id.trim())).filter(Boolean)
            : [];
        const updatedIds = Array.from(new Set([...existingIds, ...newIds]));
        const updatedString = updatedIds.join(',');

        return { [field]: updatedString };
    }
    const ConfirmUser = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (selectedRowKeysPopup.length) {
            setDisplay(true)
            let hideMessage;
            const formData = updateCampaignIds(displayData, selectedRowKeysPopup, 'Lead')
            try {
                hideMessage = message.loading("Loading...", 0);
                const response = await CampaignUpdate(formData, displayData?.campaignId)
                if (response.status === 200) {
                    message.success(`Selected leads have been successfully added to the campaign`)
                    hideMessage();
                    setDisplay(false)
                    OpenUserTable()
                    getCampaignData()
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                hideMessage();
                setDisplay(false)
                message.error(error)
            }
        }
        else {
            loadingRef.current = false;
            setDelteClick(false)
            message.error("Please select atleast one lead")
        }
    }
    const ConfirmUser1 = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (selectedRowKeysPopup.length) {
            const formattedLeads = selectedRowKeysPopup.map(id => ({
                leadId: Number(id),
                isMailSent: "No",
                leadAddedDate: getDateFromTimezoneString()
            }));
            setExistLead(prevLeads => {
                const merged = [...prevLeads, ...formattedLeads];
                const unique = merged.filter(
                    (lead, index, self) =>
                        index === self.findIndex(l => l.leadId === lead.leadId)
                );
                return unique;
            });
            loadingRef.current = false;
            setDelteClick(false)
            OpenUserTable();
        } else {
            loadingRef.current = false;
            setDelteClick(false)
            message.error("Please select at least one lead");
        }
    };
    // const ConfirmUser1 = async () => {
    //     if (selectedRowKeysPopup.length) {
    //         setExistLead((prevLeads) => {
    //             const merged = [...prevLeads, ...selectedRowKeysPopup];
    //             const unique = Array.from(new Set(merged));
    //             return unique;
    //         });
    //         OpenUserTable()
    //     }
    //     else {
    //         message.error("Please select atleast one lead")
    //     }
    // }
    const handleSearch = (searchText) => {
        setSearchText(searchText);
    };

    const filterData = (data) => {
        let filteredData = [...data];
        if (searchText) {
            filteredData = filteredData.filter(item => {
                const searchableFields = [
                    item.first_name,
                    item.last_name,
                    item.primary_email,
                    item.designation,
                    item.country
                ];
                return searchableFields.some(field =>
                    field && field.toString().toUpperCase().includes(searchText.toUpperCase())
                );
            });
        }
        return filteredData;
    };
    const applyFilters = () => {
        const filteredData = filterData(exportData);
        setFilterDatas(filteredData);
    };
    useEffect(() => {
        applyFilters();
    }, [searchText]);
    const usersTableDataPopup = [];
    if (filterDatas !== undefined) {
        filterDatas.map((user) => {
            return usersTableDataPopup.push({
                key: user.leads_id,
                name: (<div className="user-info_image table_list_clicks">
                    {user.leads_id && (user.lead_profile !== null && user.lead_profile
                        !== undefined && user.lead_profile !== "" ?
                        <figure>
                            <img style={{ width: "30px", height: "30px" }} src={user.lead_profile} alt="" />
                        </figure>
                        :
                        <span className='list_span_Tag LeadIcon'>
                            {user.first_name && user.first_name.slice(0, 1).toUpperCase()}
                        </span>
                    )}
                    {user.leads_id &&
                        <figcaption>
                            <div>
                                {`${user.first_name} ${user.last_name}`}
                            </div>
                            <div className='entityemail'>
                                {user.primary_email}
                            </div>
                        </figcaption>
                    }
                </div>),
                accountname: (<div className='table_list_clicks'>{user.account_name}</div>),
                designation: (<div className='table_list_clicks'>{user.designation}</div>),
            });
        });
    }
    return (
        <Modal
            title={
                <Row>
                    <Col xxl={4} lg={4} xs={24}>
                        <div style={{ margin: "7px 0px" }}>
                            Select Leads
                        </div>
                    </Col>
                    <Col xxl={12} lg={12} xs={24}>
                        <AutoComplete
                            onSearch={handleSearch}
                            dataSource={page === "Sequence" ? usersTableDataPopup.filter(
                                item => !selectedRowKeys.some(selected => selected.leadId === Number(item.key))
                            ) :
                                usersTableDataPopup.filter(item => !selectedRowKeys.includes(item.key))}
                            placeholder="Search by Name"
                            width="100%"
                            patterns />
                    </Col>
                </Row>
            }
            open={openUser}
            onCancel={OpenUserTable}
            maskClosable={false}
            footer={[
                <div>
                    <Button htmlType="submit" className="button_colors" onClick={() => page === "Sequence" ? ConfirmUser1() : ConfirmUser()} disabled={display || deleteClick} loading={deleteClick}>
                        {!deleteClick && <FeatherIcon icon="plus" />}Add
                    </Button>
                </div>
            ]}
            width={1000}
        >
            <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                <Table
                    showSorterTooltip={false}
                    rowSelection={rowSelectionPopup}
                    dataSource={page === "Sequence" ? usersTableDataPopup.filter(
                        item => !selectedRowKeys.some(selected => selected.leadId === Number(item.key))
                    ) :
                        usersTableDataPopup.filter(item => !selectedRowKeys.includes(item.key))}
                    columns={usersTableColumns}
                    pagination={{
                        total: (page === "Sequence" ? usersTableDataPopup.filter(
                            item => !selectedRowKeys.some(selected => selected.leadId === Number(item.key))
                        ) :
                            usersTableDataPopup.filter(item => !selectedRowKeys.includes(item.key))).length,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                />
            </div>
        </Modal >
    );
};

Popup.propTypes = {
    openUser: PropTypes.bool.isRequired,
    selectedRowKeys: PropTypes.array.isRequired,
    usersTableColumns: PropTypes.array.isRequired,
    filterDatas: PropTypes.array.isRequired,
    setFilterDatas: PropTypes.func.isRequired,
    exportData: PropTypes.array.isRequired,
    OpenUserTable: PropTypes.func.isRequired,
    displayData: PropTypes.object.isRequired,
    getCampaignData: PropTypes.func.isRequired,
    page: PropTypes.string.isRequired,
    setExistLead: PropTypes.func.isRequired,
};

export default Popup;